import React, { createContext, useCallback, useEffect, useState } from 'react';
import ErrorPage from '../pages/ErrorPage';
import LoadingPage from '../pages/LoadingPage';
import ImageViewer from '../components/ImageViewer';
import Wrapper from '../components/Wrapper';
import { useSearchParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import TagManager from 'react-gtm-module';
import i18n from '../config/i18n';
import { useFlow } from './FlowContext';

const GTM_IDS = [
  'GTM-PLBRD26'
];
const eventPages = {
  Landing_page_visit: {
    pageTitle: 'Registration Benefit 2',
    pagePath: '/2/ssr/benefit',
    pageCategory: 'Registration Benefit 2',
  },

  nav_to_country_residence: {
    pageTitle: 'Country Selection 2',
    pagePath: '/2/ssr/country',
    pageCategory: 'Country Selection 2',
  },
  nav_birth_date: {
    pageTitle: 'Date of Birth 2',
    pagePath: '/2/ssr/birthdate',
    pageCategory: 'Date of Birth 2',
  },

  nav_to_code: {
    pageTitle: 'Device Codentify 2',
    pagePath: '/2/ssr/codentify',
    pageCategory: 'Device Codentify 2',
  },
  nav_to_your_devices: {
    pageTitle: 'Device Summary 2',
    pagePath: '/2/ssr/device_summary',
    pageCategory: 'Device Summary 2',
  },

  nav_to_final_page: {
    pageTitle: 'Registration Confirmation 2',
    pagePath: '/2/ssr/confirmation',
    pageCategory: 'Registration Confirmation 2',
  },
  nav_to_number: {
    pageTitle: 'Mobile Phone 2',
    pagePath: '/2/ssr/mobile_phone',
    pageCategory: 'Mobile Phone 2',
  },
  nav_to_phone_code: {
    pageTitle: 'Phone Verification 2',
    pagePath: '/2/ssr/verification',
    pageCategory: 'Phone Verification 2',
  },
  nav_to_first_name: {
    pageTitle: 'Firstname 2',
    pagePath: '/2/ssr/firstname',
    pageCategory: 'Firstname 2',
  },
  nav_to_last_name: {
    pageTitle: 'Lastname 2',
    pagePath: '/2/ssr/lastname',
    pageCategory: 'Lastname 2',
  },
  nav_to_email: {
    pageTitle: 'Email 2',
    pagePath: '/2/ssr/email',
    pageCategory: 'Email 2',
  },
  nav_to_zip_code: {
    pageTitle: 'Zip Code 2',
    pagePath: '/2/ssr/zipcode',
    pageCategory: 'Zip Code 2',
  },
};

const initializeGTM = () => {
  GTM_IDS.forEach((gtmId) => {
    TagManager.initialize({ gtmId });
  });
};
const sendEventToGTM = (eventName) => {
  GTM_IDS.forEach((gtmId) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      gtmId,
    });
  });
};
// Create the context
const DataContext2 = createContext();
const steps = 8;

// Create a provider component
const DataContext2Provider = ({ children }) => {
  const { setFlowNumber } = useFlow();
   const [journeyData, setJourneyData] = useState({
      journey_id: uuidv4(),
      date: new Date(),
      Landing_page_visit: 0,
      language_change: 0,
      nav_to_country_residence: 0,
      nav_to_coupon: 0,
    nav_to_old_device: 0,
      nav_birth_date: 0,
      nav_to_terms: 0,
      nav_to_code: 0,
      nav_to_your_devices: 0,
      nav_to_another_code: 0,
      nav_to_final_page: 0,
      nav_to_number: 0,
      nav_to_phone_code: 0,
      nav_to_first_name: 0,
      nav_to_last_name: 0,
      nav_to_email: 0,
      nav_to_zip_code: 0,
      error_device_already_registered: 0,
      error_code_not_read: 0,
      device_added: 0,
    });
  useEffect(() => {
    setFlowNumber(2);
  }, []);
  const [gtmReady, setGTMReady] = useState(false);
  const [eventQueue, setEventQueue] = useState([]);
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(0);
   let initialDate = new Date('1980-06-15');
   const parsed = JSON.parse(localStorage.getItem('ageConfirmation') || '{}');
      const { day, month, year } = parsed;

      if (day && month && year) {
        initialDate = new Date(Number(year), Number(month) - 1, Number(day));
      }
  const [data, setData] = useState({
    country: 'luxembourg',
    uuid: uuidv4(),
    phonenumber: '+352',
    smsConfirmationCode: '',
    zip: '',
    firstname: '',
    lastname: '',
    dob: initialDate,
    email: '',
    agreements: [false, false, false],
    isCodeDisabled: false,
    code: '',
    src: '',
    isCompliant: '',
    isReturning: false,
    shopId: searchParams.get('id')?.length
      ? searchParams.get('id')
      : localStorage.getItem('shopId'),
    smsCodeSentCount: 0,
  });

  useEffect(() => {
    initializeGTM();
    setGTMReady(true);
  }, []);

  useEffect(() => {
    if (gtmReady && eventQueue.length > 0) {
      eventQueue.forEach((event) => {
        sendEventToGTM(event);
      });
      setEventQueue([]);
    }
  }, [gtmReady, eventQueue]);

 const track = (v) => {
    if (Object.keys(v)?.length && eventPages[Object.keys(v)[0]]?.pageTitle) {
      GTM_IDS.forEach((gtmId) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'virtualPageView',
virtualPageTittle: eventPages[Object.keys(v)[0]]?.pageTitle, // Please use value referred below
          virtualPageTitle: eventPages[Object.keys(v)[0]]?.pageTitle, // Please use value referred below          virtualPagePath: eventPages[Object.keys(v)[0]]?.pagePath, // Please use value referred below
          virtualPageBrand: 'iqos',
          page: {
            pageInfo: {
              pageName: eventPages[Object.keys(v)[0]]?.pageTitle, // Please use value referred below
              flow:'LEAD',

            },
            category: {
              primaryCategory: 'LUX SSR',
            },
            attributes: {
              language: i18n.language,
              country: 'LU',
              currency: 'EUR',
              
            },
            
          },
          gtmId,
        });
      });
    }
    if (Object.keys(v)?.length && Object.keys(v)[0] === 'device_added') {
      GTM_IDS.forEach((gtmId) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'deviceAction',
          deviceAction: 'Add',
          deviceCount: data?.devices?.length || 1, // Updated count of the total number of device of the user
          gtmId,
        });
      });
    }

    if (Object.keys(v)?.length && Object.values(v)[0] !== 0) {
      sendEventToGTM(Object.keys(v)[0]);
    }
    setJourneyData({ ...journeyData, lastUpdatedAt: new Date(), ...v });
  };
  /* eslint-disable react-hooks/exhaustive-deps */

  const trackEvent = useCallback((v) => {
    track(v);
  }, []);

  const value = {
    currentStep,
    setCurrentStep,
    data,
    setData,
    trackEvent,
    steps,
  };

  return (
    <DataContext2.Provider value={value}>
      <Wrapper>
        {searchParams.get('error') ? (
          <ErrorPage />
        ) : searchParams.get('loading') ? (
          <LoadingPage />
        ) : searchParams.get('image') ? (
          <ImageViewer />
        ) : (
          children
        )}
      </Wrapper>
    </DataContext2.Provider>
  );
};

export { DataContext2, DataContext2Provider };
